/**
 * Contentful client configuration
 * 
 * This file configures the Contentful client for fetching content.
 * It handles both browser and Node.js environments.
 */

// Import contentful
import * as contentful from 'contentful';

/**
 * Get environment variables from either Vite or Node.js environment
 * @param key - Environment variable key
 * @returns Environment variable value or undefined
 */
function getEnv(key: string): string | undefined {
  // Check if we're in a browser environment with Vite
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    const value = import.meta.env[key];
    console.log(`Getting env var ${key} from import.meta.env: ${value ? 'Found' : 'Not found'}`);
    return value;
  }
  // Otherwise, use Node.js process.env
  const value = process.env[key];
  console.log(`Getting env var ${key} from process.env: ${value ? 'Found' : 'Not found'}`);
  return value;
}

// Get Contentful credentials from environment variables
const SPACE_ID = getEnv('VITE_CONTENTFUL_SPACE_ID');
const ACCESS_TOKEN = getEnv('VITE_CONTENTFUL_ACCESS_TOKEN');
const ENVIRONMENT = getEnv('VITE_CONTENTFUL_ENVIRONMENT') || 'master';

console.log('Initializing Contentful client with:');
console.log('SPACE_ID:', SPACE_ID ? 'Available' : 'Not available');
console.log('ACCESS_TOKEN:', ACCESS_TOKEN ? 'Available' : 'Not available');
console.log('ENVIRONMENT:', ENVIRONMENT);

// Initialize Contentful client if credentials are available
let contentfulClient: contentful.ContentfulClientApi<undefined> | null = null;

if (SPACE_ID && ACCESS_TOKEN) {
  try {
    contentfulClient = contentful.createClient({
      space: SPACE_ID,
      accessToken: ACCESS_TOKEN,
      environment: ENVIRONMENT
    });
    console.log('Contentful client initialized successfully');
  } catch (error) {
    console.error('Error initializing Contentful client:', error);
  }
} else {
  console.warn('Contentful credentials not found in environment variables.');
}

export { contentfulClient };